import { css } from 'lit';

export default css`.fs-form-field {
  display: flex;
  gap: var(--fs-size-spacing-tiny3, 4px)
}

.fs-form-field.fs-form-field--compact {
    gap: var(--fs-size-spacing-tiny2, 2px);
  }

.fs-form-field:not(.fs-form-field--inline) {
    flex-flow: column;
  }

.fs-form-field.fs-form-field--inline {
    align-items: center;
    flex-wrap: wrap;
    gap: var(--fs-size-spacing-tiny3, 4px)
  }

.fs-form-field.fs-form-field--inline > .fs-form-field__block {
      flex: 1 1 100%;
    }

.fs-form-field.fs-form-field--alignment-start {
    align-items: flex-start;
  }

.fs-form-field.fs-form-field--alignment-center {
    align-items: center;
  }

.fs-icon-wrapper {
  display: flex;
  position: relative;
}

.fs-fieldset {
  border: 0;
  display: flex;
  flex-flow: column;
  gap: var(--fs-size-spacing-medium1, 16px);
  margin: 0;
  padding: 0
}

.fs-fieldset.fs-fieldset--compact {
    gap: var(--fs-size-spacing-small1, 8px)
  }

.fs-fieldset.fs-fieldset--compact > .fs-fieldset__legend + .fs-form-field {
        margin-top: var(--fs-size-spacing-medium1, 16px);
      }

.fs-fieldset > .fs-fieldset__legend {
    padding: 0
  }

.fs-fieldset > .fs-fieldset__legend + .fs-form-field {
      margin-top: var(--fs-size-spacing-medium1, 16px);
    }`;